import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { IconArrowLeft, IconBurguer, IconClose, LogoWhite } from "../../assets/svgs-index";
import CompanyPhoneInfo from "../../components/CompanyCard/CompanyCardInfo/CompanyPhoneInfo";
import CompanyWebLinkInfo from "../../components/CompanyCard/CompanyCardInfo/CompanyWebLinkInfo";
import "./Sidebar.scss";
import { Helper, HelperWebView, HelperConfig } from "../../core/services/helper/helper.service";
import { AppStorage } from "../../core/storage/app-storage";
import LinkButton from "../../components/buttons/LinkButton/LinkButton";
import { CommonLabels } from "../../assets/labels/labels";
import Emitter from "../../core/services/emitter";
import AndroidBack from "../../core/services/androidBack.service";


const Sidebar: React.FC<any> = () => {
  // eslint-disable-next-line
  const appVersion = "v2026.07.03";
  // eslint-disable-next-line
  const nativeAppToken = HelperWebView.nativeAppToken();
  const currentPath: string = window.location.pathname;
  const cookies = useMemo(() => new Cookies(), []);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  // const [drawerOpen, setDrawerOpen] = useState(false);
  const [sessionToken, setSessionToken] = useState(cookies.get('sessionToken'));
  const [companiesShown, setCompaniesShown] = useState(false);

  useEffect(() => {
    if (HelperWebView.isAndroidWebview()) {
      Emitter.on('CLOSE_SIDEBAR', () => {
        setIsOpen(false);
      });
      Emitter.on('OPEN_SIDEBAR', () => {
        setIsOpen(true);
      });
    }
    Emitter.on('SIDEBAR_ICON_TYPE', (value) => {
      setCompaniesShown(value);
    });
  }, []);

  useEffect(() => {
    if (HelperWebView.isAndroidWebview()) {
      AndroidBack.setMenuOpen(isOpen);
    }
  }, [isOpen]);

  useEffect(() => {
    // Update the sessionToken state whenever the "sessionToken" cookie changes
    const handleCookieChange = () => {
      setSessionToken(cookies.get("sessionToken"));
    };

    // Attach the listener for changes
    cookies.addChangeListener(handleCookieChange);

    // Cleanup: Remove the listener when the component unmounts
    return () => {
      cookies.removeChangeListener(handleCookieChange);
    };
  }, [cookies]);


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleCTA = (path: string, e: any) => {
    e.stopPropagation();
    toggleSidebar();
    setTimeout(() => {
      navigate(path);
    }, 500);
  };

  const handleLogout = (e: any) => {
    const eventInfo = {
      auth_token: cookies.get('sessionToken'),
      route: cookies.get('route'),
      client_route: cookies.get('clientroute')
    };
    if (HelperWebView.isIOSWebview()) {
      try {   
        (window as any).webkit.messageHandlers.logout.postMessage(eventInfo);
      } catch (error) {
        console.error(error);
      }
    }
    if (HelperWebView.isAndroidWebview()) {
      try {
        (window as any).Android.logout(eventInfo.auth_token, eventInfo.route, eventInfo.client_route);
      } catch (error) {
        console.error(error);
      }
    }
    e.stopPropagation();
    setSessionToken(undefined);
    Helper.removeCookie('sessionToken');
    cookies.remove('liteToken', HelperConfig.cookiesLiteConfig);
    cookies.remove('liteEmail', HelperConfig.cookiesLiteConfig);
    cookies.remove('litePhone', HelperConfig.cookiesLiteConfig);
    cookies.remove('userId', HelperConfig.cookiesLiteConfig);
    Helper.setCookiesToApp();
    AppStorage.selectedCompany = undefined;
  };

  const renderCTAbuttons = () => {
    if (sessionToken) {
      return (
        <button className="cta-button-primary dark w-100" onClick={handleLogout}>
          {"Terminar Sessão"}
        </button>
      );
    }

    return (
      <React.Fragment>
        <button className="cta-button-primary dark w-100" onClick={(e) => handleCTA("/login", e)}>
          {"Iniciar sessão"}
        </button>
        <button
          className="cta-button-secondary dark w-100 mt-4 "
          onClick={(e) => handleCTA("/registo", e)}
        >
          {"Registar"}
        </button>
      </React.Fragment>
    );
  };

  const renderTriggerButton = () => {
    if (Helper.isAuthPage(currentPath)) {
      return (
        <button onClick={() => navigate("/")} className="toggle-button w-auto">
          <LinkButton
            onClick={() => {}}
            styleClass="link-container backHomepage ms-0 ms-md-2 mt-md-2"
            valueText={CommonLabels.backHomepage}
            icon={IconArrowLeft}
          />
      </button>
      );
    }
    return (
      <button onClick={toggleSidebar} className="toggle-button w-auto button">
        {companiesShown ? (
          <img src={IconBurguer} alt="toggle-sidebar" />
        ) : (
          <LinkButton
            onClick={() => { }}
            styleClass="link-container backHomepage ms-0 ms-md-2 mt-md-2"
            valueText={sessionToken ? CommonLabels.openSideBarAuthenticated : CommonLabels.openSideBar}
            textClass={sessionToken ? '' : 'large'}
            icon={IconArrowLeft}
          />
        )}
      </button>
    );
  };

  const renderPrivacyTerms = () => {
    const showPrivacyTermsFooter = true; //HelperWebView.isAndroidWebview();
    return (
      <>
        {showPrivacyTermsFooter && (
          <div className="text-center d-inline-flex justify-content-center w-100 mt-1">
            <LinkButton
              onClick={() => Emitter.emit("OPEN_IAGREE_TEXT", null)}
              styleClass="link-container ms-0 ms-md-2 mt-md-2"
              textClass="small"
              valueText={"Política de Privacidade"}
            />
            <div className="mx-1 small"> </div>
            <LinkButton
              onClick={() => { window.open('https://www.keymaster.pt/termos-e-condicoes/', '_self') }}
              styleClass="link-container ms-0 ms-md-2 mt-md-2"
              textClass="small"
              valueText={"Termos & Condições"}
            />
          </div>
        )}
      </>
    )
  }

  return (
    <React.Fragment>
      {renderTriggerButton()}
      <div className={`drawer-layer ${isOpen ? "open" : ""}`} onClick={() => isOpen && toggleSidebar()}>
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
          <button onClick={toggleSidebar} className="toggle-button open">
            <img src={IconClose} alt="close-sidebar" />
          </button>
          <div className="content h-100 mt-5 d-flex flex-column justify-content-center">
            <div className="cta-buttons-container w-100 mt-5 d-flex flex-column justify-content-center">
              {renderCTAbuttons()}
            </div>

            <div className="line-divider mt-5"></div>

            <div className="bottom-info-container pb-2">
              <div className="logo-container" role="button" onClick={(e) => handleCTA("/", e)}>
                <img src={LogoWhite} alt="app-logo"></img>
              </div>

              <div className="address-info-container mt-5">
                <div className="address-info">
                  Av. D. Pedro I, nº 275 R/C, 2750-786 Cascais, Portugal
                </div>
                <div className="contact-links-container align-items-center mt-1">
                  <CompanyWebLinkInfo
                    darkMode={true}
                    company={{
                      name: "Keymaster",
                      email: "info@keymaster.pt",
                      website: "https://www.keymaster.pt",
                    }}
                  />
                </div>
                <div className="contact-links-container">
                  <CompanyPhoneInfo company={{ name: "Keymaster", phone: "+351911775859" }} darkMode={true} />
                </div>
              </div>
              <div className="text-center w-100 app-version mt-0">{/*appVersion*/}</div>
              <div className="text-center w-100 app-version mt-0">{/*nativeAppToken*/}</div>
              {renderPrivacyTerms()}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
